import { render, staticRenderFns } from "./CompactEditSimpleLookupComponent.vue?vue&type=template&id=10767149&scoped=true&"
import script from "./CompactEditSimpleLookupComponent.vue?vue&type=script&lang=js&"
export * from "./CompactEditSimpleLookupComponent.vue?vue&type=script&lang=js&"
import style0 from "./CompactEditSimpleLookupComponent.vue?vue&type=style&index=0&id=10767149&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10767149",
  null
  
)

export default component.exports